export type ClipCoverOverride = { url: string | null } | null;

/** The override (including an explicit null removal) wins over the fetched url. */
export function resolveClipCardCoverUrl({
  fetchedUrl,
  override,
}: {
  fetchedUrl: string | null | undefined;
  override: ClipCoverOverride;
}): string | null {
  if (override) return override.url;
  return typeof fetchedUrl === 'string' && fetchedUrl.startsWith('https://') ? fetchedUrl : null;
}

export function canSetClipCover({
  canSetCover,
  finishedVideoUrl,
  isRendered,
  isExpired,
}: {
  canSetCover: boolean | null | undefined;
  finishedVideoUrl: string | null | undefined;
  isRendered: boolean;
  isExpired: boolean;
}): boolean {
  return canSetCover === true && !!finishedVideoUrl && isRendered && !isExpired;
}

export function resolveRenderedCoverAspect({ width, height }: { width: number; height: number }): number {
  return width > 0 && height > 0 ? width / height : 9 / 16;
}

export function resolveClipCoverReferenceTime({
  lastPickedTime,
  duration,
}: {
  lastPickedTime: number | null;
  duration: number;
}): number {
  if (lastPickedTime !== null && Number.isFinite(lastPickedTime) && lastPickedTime >= 0) return lastPickedTime;
  return duration > 0 ? duration / 2 : 0;
}
